<template>
  <a v-if="!isEmptyLink" :href="link" class="default" @click.capture="onClick" :class="classNames">
    <slot></slot>
  </a>
  <a v-else class="default" :class="classNames" @click.stop="clickEvent">
    <slot></slot>
  </a>
</template>

<script>
export const ColorType = Object.freeze({
  brand: 'brand',
  gray: 'gray',
  black: 'black',
  white: 'white',
  disable: 'disable',
  inactive: 'inactive',
  warning: 'warning',
  emergency: 'emergency'
})

import Types from '@/utils/types'
import _ from 'lodash'

export default {
  name: 'VA',
  props: {
    color: {
      type: String,
      default: ColorType.brand
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    classNames() {
      return [`${this.color}-color`]
    },
    isEmptyLink() {
      return this.link === ''
    }
  },
  methods: {
    clickEvent() {
      if (this.isTransition) return

      this.onClick()
      this.isTransition = true

      setTimeout(() => {
        this.isTransition = false
      }, 2000)
    }
  },
  data() {
    return {
      isTransition: false
    }
  }
}
</script>

<style lang="scss" scoped>
.default {
  width: auto;
  height: auto;
  white-space: nowrap;

  cursor: pointer;
}
</style>